// Libs
import moment from 'moment';

// Store
import store from '../store';

// Services
import api from './api';

export default {
  phoneMask: (phone) => {
    // Takes a 10 digits string/integer and formats it from 9999999999 to (999) 999-9999
    // (999) 999-9999 => (partA) partB-partC
    const partA = phone.substring(0, 3);
    const partB = phone.substring(3, 6);
    const partC = phone.substring(6, 10);
    return phone ? `(${partA}) ${partB}-${partC}` : '';
  },

  // Get shopper config
  getShopperConfig: async () => {
    const { status, data } = await api({
      url: '/api/shopper/',
      method: 'OPTIONS',
    });
    if (status !== 200) {
      alert('Swapper configuration not valid.');
      return;
    }
    // Set config in store
    const { actions: { POST: shopperConfig } } = data;
    store.dispatch('shopper/storeConfig', shopperConfig);
  },

  formatDate: ({ date, inFormat, outFormat }) => moment(date, inFormat).format(outFormat),

  // Change case for for shopper properties
  mapShopper: ({ shopper, toCamelCase }) => {
    if (toCamelCase) {
      const {
        id,
        city,
        state,
        first_name: firstName,
        last_name: lastName,
        phone_number: phone,
        address_1: address1,
        address_2: address2,
        email_address: email,
        zip_code: zipcode,
        drivers_license:
        license,
        date_of_birth: dob
      } = shopper;
      return {
        id,
        firstName,
        lastName,
        phone,
        address1,
        address2,
        state,
        city,
        zipcode,
        dob,
        license,
        email
      };
    }
    // To snake case
    const {
      id,
      city,
      state,
      firstName: first_name,
      lastName: last_name,
      phone: phone_number,
      address1: address_1,
      address2: address_2,
      email: email_address,
      zipcode: zip_code,
      license: drivers_license,
      dob: date_of_birth
    } = shopper;
    return {
      id,
      city,
      state,
      first_name,
      last_name,
      phone_number,
      address_1,
      address_2,
      email_address,
      zip_code,
      drivers_license: drivers_license ? drivers_license.toUpperCase() : null,
      date_of_birth: date_of_birth || null
    };
  },

  // Centralize shopper rules so they can be reused
  createShopperRules: () => {
    const {
      first_name,
      last_name,
      email_address,
      phone_number,
      city,
      state,
      address_1,
      address_2,
      zip_code,
      date_of_birth,
      drivers_license
    } = store.getters['shopper/shopperConfig'];
    return {
      firstName: [
        { required: first_name.required, message: 'This field is required.' },
        { max: first_name.max_length, message: `Only accepts up to ${first_name.max_length} characters.` }
      ],
      lastName: [
        { required: last_name.required, message: 'This field is required.' },
        { max: last_name.max_length, message: `Only accepts up to ${last_name.max_length} characters.` }
      ],
      phone: [
        { required: phone_number.required, message: 'This field is required.' },
        {
          type: phone_number.type,
          validator: (rule, value, callback) => {
            if (value.toString().length !== parseInt(phone_number.max_length, 10)) {
              return callback(new Error(`Please enter ${phone_number.max_length} digits.`));
            }
            callback();
          }
        }
      ],
      dob: [
        { required: true, message: 'This field is required.' }
      ],
      birth_day: [
        {required: true, message: 'This field is required'}
      ],
      birth_month: [
        {required: true, message: 'This field is required'}
      ],
      birth_year: [
        {required: true, message: 'This field is required'}
      ],
      license: [
        { required: true, message: 'This field is required.' },
        { max: drivers_license.max_length, message: `Only accepts up to ${drivers_license.max_length} characters.` }
      ],
      email: [
        { required: email_address.required, message: 'This field is required.' },
        { max: email_address.max_length, message: `Only accepts up to ${email_address.max_length} characters.` },
        { type: email_address.type, message: 'Invalid email.' }
      ],
      city: [
        { required: city.required, message: 'This field is required.' },
        { max: city.max_length, message: `Only accepts up to ${city.max_length} characters.` }
      ],
      state: [
        { required: state.required, message: 'This field is required.' },
        { max: state.max_length, message: `Only accepts up to ${state.max_length} characters.` }
      ],
      address1: [
        { required: address_1.required, message: 'This field is required.' },
        { max: address_1.max_length, message: `Only accepts up to ${address_1.max_length} characters.` }
      ],
      address2: [
        { max: address_2.max_length, message: `Only accepts up to ${address_2.max_length} characters.` }
      ],
      zipcode: [
        { required: zip_code.required, message: 'This field is required.' },
        {
          type: zip_code.type,
          validator: (rule, value, callback) => {
            if (value.toString().length !== parseInt(zip_code.max_length, 10)) {
              return callback(new Error(`Please enter ${zip_code.max_length} digits.`));
            }
            callback();
          }
        }
      ]
    };
  }
};
